module.exports = __webpack_public_path__ + "img/dynamic-23.1bc57738.png";